module.exports = __webpack_public_path__ + "static/media/background_mobile_iphone6.4690ce28.jpg";